module.exports = __webpack_public_path__ + "img/1.16b94701.png";